import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from './AuthContext';

export const AuthenticatedRoute = props => {
    const auth = useContext(AuthContext);
    return auth.isLoggedIn ? <Route {...props} /> : <Redirect to={{ pathname: "/" }} />
}
